// src/components/MessageBoard.jsx
import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'messageBoardData';

export default function MessageBoard({ userName = 'User' }) {
  const [messages, setMessages] = useState([]);
  const [newText, setNewText] = useState('');

  useEffect(() => {
    // Always fetch remote messages, then merge with stored edits
    fetch('/messages.json')
      .then(res => res.json())
      .then(remoteMessages => {
        const storedStr = localStorage.getItem(STORAGE_KEY);
        let merged;
        if (storedStr) {
          const stored = JSON.parse(storedStr);
          // keep only stored entries not in remote (by unique timestamp and user/text)
          const newEdits = stored.filter(s =>
            !remoteMessages.some(r =>
              r.timestamp === s.timestamp && r.user === s.user && r.text === s.text
            )
          );
          merged = [...remoteMessages, ...newEdits];
        } else {
          merged = remoteMessages;
        }
        setMessages(merged);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
      })
      .catch(err => console.error('Failed to load messages:', err));
  }, []);

  const handleAdd = (e) => {
    e.preventDefault();
    if (!newText.trim()) return;
    const newMsg = {
      user: userName,
      timestamp: new Date().toISOString(),
      text: newText.trim()
    };
    const updated = [...messages, newMsg];
    setMessages(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    setNewText('');
  };

  return (
    <div className="space-y-4">
      <div className="max-h-60 overflow-y-auto space-y-3">
        {messages.map((msg, idx) => (
          <div key={idx} className="p-3 bg-white bg-opacity-30 dark:bg-opacity-20 rounded-md">
            <div className="flex justify-between text-sm text-gray-600 dark:text-gray-400 mb-1">
              <span>{msg.user}</span>
              <span>{new Date(msg.timestamp).toLocaleString()}</span>
            </div>
            <div className="text-gray-800 dark:text-gray-100">
              {msg.text}
            </div>
          </div>
        ))}
      </div>
      <form onSubmit={handleAdd} className="flex space-x-2">
        <input
          type="text"
          value={newText}
          onChange={(e) => setNewText(e.target.value)}
          placeholder="Write a message..."
          className="flex-1 px-3 py-2 rounded-md bg-white bg-opacity-80 dark:bg-gray-700 dark:bg-opacity-80 focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition"
        >
          Post
        </button>
      </form>
    </div>
  );
}